import { render, staticRenderFns } from "./PrePostTotalByObjects.vue?vue&type=template&id=e4aad300"
import script from "./PrePostTotalByObjects.vue?vue&type=script&lang=js"
export * from "./PrePostTotalByObjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports